























import TimeRangeControls from "@/components/TimeRangeControls.vue";
import ProcessedStatsChart from "@/components/ProcessedStatsChart.vue";
import GetProcessedStats from "@/mixins/get-processed-stats";
import { getTitle } from "@/utils/chart";
import { Component, Mixins } from "vue-property-decorator";

@Component({ components: { TimeRangeControls, ProcessedStatsChart } })
export default class MetricsView extends Mixins(GetProcessedStats) {
  created() {
    this.getProcessedStats();
  }

  beforeDestroy() {
    this.cleanUpProcessedStats();
  }

  chartIDs = ["memory", "items", "requestRate", "requestDistribution", "connections", "dataTraffic"];

  featuredChartID = "hitRate";

  chartTitle(chartID: string): string {
    return getTitle(chartID);
  }
}
